module.exports = __webpack_public_path__ + "img/culture.ca5b1202.png";